import React from 'react';
import { Link } from 'react-router-dom';

export default function IndexSection__forms3() {
    return (
        <React.Fragment>
            <>
                <section className="py-12 lg:py-20"><div className="container mx-auto px-4 mb-12 md:mb-20"><div className="flex flex-wrap -mx-4">
      <div className="w-full lg:w-1/3 px-4 mb-6 lg:mb-0">
        <Link to="/" className="inline-block mb-5 text-gray-900 text-lg font-semibold"><img className="h-16" src="https://static.shuffle.dev/uploads/files/07/07cb578ecf8a7dc45b27c26595d450c94e67c7d2/ChatGPT-Image-Jul-14-2025-10-10-58-AM.png" alt="Ordio Logo" width="auto" /></Link><p className="mb-6 max-w-sm text-base text-gray-500">AI-powered sorting made simple. Organize your digital life with intelligent algorithms.</p>
        <div>
          <a className="inline-block w-10 mr-4" href="#" /><a className="inline-block w-10 mr-4" href="#" /><a className="inline-block w-10 mr-4" href="#" />
        </div>
      </div>
      <div className="w-full lg:w-2/3 px-4"><div className="flex flex-wrap justify-between -mx-4">
          <div className="w-1/2 lg:w-1/4 px-4 mb-8 lg:mb-0">
            <h3 className="mb-6 text-base font-medium">Product</h3>
            <ul className="text-sm">
              <li className="mb-4"><a className="text-gray-500 hover:text-gray-600" href="#features">Features</a></li>
              <li className="mb-4"><a className="text-gray-500 hover:text-gray-600" href="#pricing">Pricing</a></li>
              <li className="mb-4"><Link to="/register" className="text-gray-500 hover:text-gray-600">Demo</Link></li>
              <li><Link to="/register" className="text-gray-500 hover:text-gray-600">Get Started</Link></li>
            </ul>
          </div>
          <div className="w-1/2 lg:w-1/4 px-4 mb-8 lg:mb-0">
            <h3 className="mb-6 text-base font-medium">Support</h3>
            <ul className="text-sm">
              <li className="mb-4"><a className="text-gray-500 hover:text-gray-600" href="#faq">FAQ</a></li>
              <li className="mb-4"><a className="text-gray-500 hover:text-gray-600" href="#faq">Help Center</a></li>
              <li className="mb-4"><Link to="/dashboard" className="text-gray-500 hover:text-gray-600">Dashboard</Link></li>
              <li><a className="text-gray-500 hover:text-gray-600" href="#contact">Contact</a></li>
            </ul>
          </div>
          <div className="w-1/2 lg:w-1/4 px-4 mb-8 lg:mb-0">
            <h3 className="mb-6 text-base font-medium">Company</h3>
            <ul className="text-sm">
              <li className="mb-4"><a className="text-gray-500 hover:text-gray-600" href="#features">About</a></li>
              <li className="mb-4"><Link to="/login" className="text-gray-500 hover:text-gray-600">Careers</Link></li>
              <li className="mb-4"><a className="text-gray-500 hover:text-gray-600" href="#contact">News</a></li>
              <li><a className="text-gray-500 hover:text-gray-600" href="#contact">Blog</a></li>
            </ul>
          </div>
          <div className="w-1/2 lg:w-1/4 px-4">
            <h3 className="mb-6 text-base font-medium">Legal</h3>
            <ul className="text-sm">
              <li className="mb-4"><a className="text-gray-500 hover:text-gray-600" href="#">Privacy</a></li>
              <li className="mb-4"><a className="text-gray-500 hover:text-gray-600" href="#">Terms</a></li>
              <li className="mb-4">
              </li><li>
              </li></ul>
          </div>
        </div></div>
    </div></div>
  <p className="text-center text-sm text-gray-500 pt-8 px-4 border-t">All rights reserved © Ordio 2025</p></section>


            </>
        </React.Fragment>
    );
}

